import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-box" }

import { computed } from 'vue'
import VuePannellum from 'vue-pannellum/src/vue-pannellum.vue'

import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'OverlayPanoramView',
  setup(__props) {

const store = useStore()
const pannoramaUrl = computed(() => store.state.pannoramaUrl)

function closeModal() {
  window.URL.revokeObjectURL(pannoramaUrl.value)
  store.commit('SET_CURRENT_PANORAMA_URL', '')
  store.commit('SET_STATUS_ON_SHOW_OVERLAY_MODAL', { toggleModal: false })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ButtonSquare, {
        class: "close-button",
        imgSource: require('@/assets/icons-general/icon-close-cross-small.svg'),
        size: "small",
        onClicked: closeModal
      }, null, 8, ["imgSource"]),
      _createVNode(VuePannellum, {
        width: "100%",
        height: "100%",
        showFullscreen: true,
        showZoom: true,
        src: pannoramaUrl.value
      }, null, 8, ["src"])
    ])
  ]))
}
}

})